import { TReduxActions } from '../../../types/redux';
import { FILTER_SET_COWORKING_ID_TYPE } from '../../../constants/action_types';
import { IJsonQuery, JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function setCoworkingIdReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions) {
  switch (action.type) {
    case FILTER_SET_COWORKING_ID_TYPE:
      return new JsonQuery(jsonQuery)
        .clearGeo()
        .setVillage(undefined)
        .setCoworkingIds(action.coworkingIds)
        .getSerializable();
  }

  return jsonQuery;
}
